import React, { useEffect, useRef, useState } from "react";
import useInbox from "hooks/useInbox.ts";
import { useContent } from "contexts/contentContext/contentContext.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import CustomPopup from "../../Popups/CustomPopup.js";
import { inboxSoringOptions } from "../../helpers.js";
import useQueryParams from "hooks/useQueryParams.ts";

const InboxSortingComponent = () => {
  const { getSorting, setSorting } = useInbox();
  const { getQueryParam, setQueryParams } = useQueryParams();

  const [showSorting, setShowSorting] = useState(false);

  const { getTextByKey } = useContent();

  const sortRef = useRef();
  useOnClickOutside(sortRef, () => setShowSorting(false));

  useEffect(() => {
    return () => {
      setQueryParams({
        sort: undefined,
      });
    };
  }, []);

  const handelClick = (sortBy, isCurrent) => {
    setSorting({
      by: sortBy,
      asc: isCurrent ? !getSorting().asc : true,
    });
    setTimeout(() => {
      setShowSorting(false);
    }, 300);
  };

  const handleSortIconClick = () => {
    if (getQueryParam("t") === "picker") {
      setSorting({
        by: "date",
        asc: !getSorting().asc,
      })
    } else {
      setShowSorting((prev) => !prev);
    }
  };

  return (
    <div className="inbox-mail-sorting" ref={sortRef}>
      <Tooltip
        id={"sortingTooltip"}
        tooltipTextKey={`sort-icon-tooltip-text${
          getQueryParam("t") === "picker" ? "-picker" : ""
        }`}
        start
      >
        <Icon name="sort" gray onClick={handleSortIconClick} />
      </Tooltip>
      <CustomPopup showState={showSorting} topPosition={30}>
        <div className="sorting-list-menu">
          {Object.keys(inboxSoringOptions).map((sortBy) => {
            const isCurrent =
              sortBy.toLowerCase() === getSorting().by.toLowerCase();
            return (
              <div
                className={`sorting-option${isCurrent ? " sorted" : ""}`}
                key={sortBy}
                onClick={() => handelClick(sortBy, isCurrent)}
              >
                {getTextByKey(inboxSoringOptions[sortBy])}
                {isCurrent ? (
                  <Icon
                    name="arrow-down-solid"
                    iconClass={!getSorting().asc ? "vertical-flipped" : ""}
                    small
                    blue
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      </CustomPopup>
    </div>
  );
};

export default InboxSortingComponent;
